export default {
  paymentUrl: null,
  successPaymentUrl: null,
};
